import { toast } from 'react-toastify';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { memo } from 'react';

interface Props {
    hideIconUnlessHover?: boolean;
    text: string;
}

function CopyToClipboardButton({ hideIconUnlessHover = false, text }: Props) {
    return (
        <ThemeProvider theme={theme}>
            <Button
                sx={{
                    '&:hover .copy-icon': hideIconUnlessHover ? { display: 'block' } : {},
                }}
                endIcon={
                    <ContentCopyIcon
                        className="copy-icon"
                        sx={hideIconUnlessHover ? { display: 'none' } : {}}
                    />
                }
                onClick={(e) => {
                    navigator.clipboard.writeText(text);
                    e.preventDefault();
                    e.stopPropagation();
                    toast.info(`text copied: ${text}`);
                }}
                style={{ color: 'rgba(0, 0, 0, 0.87)' }}
                size="small"
            >
                <Typography>{text}</Typography>
            </Button>
        </ThemeProvider>
    );
}

const theme = createTheme({
    typography: { button: { textTransform: 'none' } },
});

export default memo(CopyToClipboardButton);
